import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title}封面`}
          title={`${article.title} - 日漫精选推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {article.categoryName}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
          <i className="ri-star-fill" aria-hidden="true" />
          {article.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-5 text-foreground-600 md:text-sm">
          {article.summary}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" aria-hidden="true" />
            {article.year}
          </span>
          <span className="flex flex-wrap gap-1">
            {article.tags.slice(0, 2).map((t) => (
              <span key={t} className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                {t}
              </span>
            ))}
          </span>
        </div>
      </div>
    </Link>
  );
}